import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'concat',
    standalone: false
})
export class ConcatPipe implements PipeTransform {

  transform(value: any): any {
    const newValue = value?.toLowerCase()?.split(' ')?.join('-');
    return newValue?.split('--').join('-');
  }

}
